<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">解决方案</div></div>
                <div class="title">金融行业</div>
                <div class="minTitle">基于金融业提供端到端的科技信息化业务服务，积累了丰富的业务和技术知识。公司具备安全稳定的产品和定制化信息技术服务能力，拥有一支经验丰富的金融业服务团队和技术支撑团队，结合自身优势和客户需求，为客户打造真正有价值的金融科技信息化业务解决方案。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       <picture>
        <source srcset="@/assets/images/jr1_mb.jpg" media="(max-width:768px)" alt="">
        <img class="flashImg" src="@/assets/images/jr1.png" />
    </picture>
       <div class="lxwm2 bg1">
            <div class="content">
                <div class="title1 tc">方案优势</div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/jr2.png" />
                            <div class="lb">
                                丰富的金融行业案例积累
                            </div>
                        </div>
                        <div class="minTitle2 ">舟恩自成立即专注于金融行业领域，在银行、保险、基金、证券等业务有着深厚的案例积累，为客户提供全方位的技术服务，解决方案。助力客户实现随需应变，构建灵活、创新、完整、专业的业务体系。</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/jr3.png" />
                            <div class="lb">
                                专业的技术团队
                            </div>
                        </div>
                        <div class="minTitle2 ">舟恩拥有专业化的系统开发和集成专家，拥有丰富的项目实施和管理经验，技术团队核心成员曾长期任职于国内大型银行、保险、证券等机构，具备丰富的金融行业实践经验。</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/jr4.png" />
                            <div class="lb">
                                规范的服务体系
                            </div>
                        </div>
                        <div class="minTitle2 ">舟恩遵循CMMI、ISO9001标准规范并结合项目经验，形成规范的交付管理及质量管理体系。为客户提供高效、创新、完善的IT服务，助力客户提示企业管理水平，优化信息架构，降低企业开发和运营成本。</div>
                    </div>
                </div>
            </div>
       </div>
       <div class="botton">
            <div class="content">
                <div class="leftImg">
                </div>
                <div class="rightCon">
                    <div class="title1 mt20 tc pb20"></div>
                    <div class="tab" :class="tab == 1? 'active': ''" @click="tab = 1">账管系统</div>
                    <div class="tab" :class="tab == 2? 'active': ''" @click="tab = 2">受托系统</div>
                    <div class="tab" :class="tab == 3? 'active': ''" @click="tab = 3">ODS数据平台</div>
                    <div class="tab" :class="tab == 4? 'active': ''" @click="tab = 4">精准营销服务平台</div>
                    <div class="tab" :class="tab == 5? 'active': ''" @click="tab = 5">合规风险监测平台</div>
                    <div class="tabM" v-show="tab == 1">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">方案简介</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    本系统包括企业客户信息维护、企业计划信息维护、个人计划信息维护、产品信息维护、投资信息维护、直接缴费处理、规则缴费处理、企业缴费处理、支付信息维护、账户划转维护、职工转移信息维护、企业转移信息维护、投资转换处理、申购赎回处理、账管费管理、业务冲突通知、日终处理、财务接口、受托系统接口等功能模块。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabM" v-show="tab == 2">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">方案简介</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    本系统包括缴费管理、支付合规处理、转移合规处理、产品相关费用管理、净资产报表管理、各类指令生 成、外边账管指令监控、指令回盘、指令监控、指令作废、指令批处理、产品信息维护、投资信息维护、 合规规则维护、客户信息维护、计划信息维护、合同信息维护、综合查询、报表、工作流管理、系统参数 配置等模块 。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabM" v-show="tab == 3">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">方案简介</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    作为全司的数据中心，统一为全司的目标系统提供数据；屏蔽目标系统对源系统的直接数据需求，建立统 一、层次合理的数据模型，集中管理全司的业务源数据；提供标准化的数据采集、数据整合、数据转换清 洗的ETL体系，提供统一的ETL调度监控；提供有效的数据质量提升机制，为全司提供准确、全面、可靠 的数据资源，使企业的数据处于整体有序管理的状态。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabM" v-show="tab == 4">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">方案简介</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    旨在为有需求的客户提供更为便捷的投保体验、理赔查询等服务。通过该系统及时向客户传递各类服务信 息，与客户进行针对性更强的互动交流，提高客户服务水平，增强营销服务能力。可利用该平台扩展其客 户视图,助力客户分析及营销服务分析,制定营销策略。
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabM" v-show="tab == 5">
                        <div class="tabCon" >
                            <img class="titleImg" src="@/assets/images/gj8.png" />
                            <div class="tabTitle">方案简介</div>
                            <div class="tabConItems">
                                <div class="minTitle2">
                                    收集多家大中型保险公司历年的合规风险数据，梳理出150+合规规则，涵盖各业务流程节点；完整的监 测闭环；提供从规则定义-规则发布-规则执行-整改跟踪-违规问责的合规风险监测全生命周期的管理。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
       <div class="mb_button">
        <el-carousel arrow="never" :height="flashHeight" ref="carousel" :autoplay="false">
            <el-carousel-item>
                <div class="block">
                    <div class="tit">账管系统</div>
                    <div class="t"> <img class="titleImg" src="@/assets/images/gj8.png" />方案简介</div>
                    <div class="con">
                        本系统包括企业客户信息维护、企业计划信息维护、个人计划信息维护、产品信息维护、投资信息维护、直接缴费处理、规则缴费处理、企业缴费处理、支付信息维护、账户划转维护、职工转移信息维护、企业转移信息维护、投资转换处理、申购赎回处理、账管费管理、业务冲突通知、日终处理、财务接口、受托系统接口等功能模块。
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="block">
                    <div class="tit">受托系统</div>
                    <div class="t"> <img class="titleImg" src="@/assets/images/gj8.png" />方案简介</div>
                    <div class="con">
                        本系统包括缴费管理、支付合规处理、转移合规处理、产品相关费用管理、净资产报表管理、各类指令生 成、外边账管指令监控、指令回盘、指令监控、指令作废、指令批处理、产品信息维护、投资信息维护、 合规规则维护、客户信息维护、计划信息维护、合同信息维护、综合查询、报表、工作流管理、系统参数 配置等模块 。
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="block">
                    <div class="tit">ODS数据平台</div>
                    <div class="t"> <img class="titleImg" src="@/assets/images/gj8.png" />方案简介</div>
                    <div class="con">
                        作为全司的数据中心，统一为全司的目标系统提供数据；屏蔽目标系统对源系统的直接数据需求，建立统 一、层次合理的数据模型，集中管理全司的业务源数据；提供标准化的数据采集、数据整合、数据转换清 洗的ETL体系，提供统一的ETL调度监控；提供有效的数据质量提升机制，为全司提供准确、全面、可靠 的数据资源，使企业的数据处于整体有序管理的状态。
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="block">
                    <div class="tit">精准营销服务平台</div>
                    <div class="t"> <img class="titleImg" src="@/assets/images/gj8.png" />方案简介</div>
                    <div class="con">
                        旨在为有需求的客户提供更为便捷的投保体验、理赔查询等服务。通过该系统及时向客户传递各类服务信 息，与客户进行针对性更强的互动交流，提高客户服务水平，增强营销服务能力。可利用该平台扩展其客 户视图,助力客户分析及营销服务分析,制定营销策略。
                    </div>
                </div>
            </el-carousel-item>
            <el-carousel-item>
                <div class="block">
                    <div class="tit">合规风险监测平台</div>
                    <div class="t"> <img class="titleImg" src="@/assets/images/gj8.png" />方案简介</div>
                    <div class="con">
                        收集多家大中型保险公司历年的合规风险数据，梳理出150+合规规则，涵盖各业务流程节点；完整的监 测闭环；提供从规则定义-规则发布-规则执行-整改跟踪-违规问责的合规风险监测全生命周期的管理。
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
       </div>
       <div class="lxwm2 bg2">
            <div class="content" style="display: none;">
                <div class="title1 tc">合作客户</div>
                <img class="bttonImg" src="@/assets/images/jr6.png" />
            </div>
       </div>
    </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui'
    export default {
        components: {
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem
        },
        data() {
            return {
                windowWidth: '', //获取屏幕宽度
                flashHeight: '320px',  // flash高度
                tab: 1
            }
        },
        methods: {
            loadFlashImg() {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
                var that = this
                window.onresize = () => {
                    return (() => {
                        that.windowWidth = that.$refs.index.offsetWidth //获取屏幕宽度
                    })()
                }
            },
            startAuto() {
                var that = this
                if(that.autoplay == false){
                    that.autoplay = true;
                }
            },
            stopAuto() {
                var that = this
                if(that.autoplay == true){
                    that.autoplay = false;
                }
            },
            slideBanner1() {
                var that = this
                var box = document.querySelector('.mb_button .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel.prev();
                        return;
                    }
                });
            },
        },
        watch: {
            windowWidth (val) {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
            }
        },
        mounted() {
            this.slideBanner1()
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bttonImg {
            width: 100%;
            height: auto;
            margin-top: 30px;
        }
        .botton {
            min-height: 370px;
            background: url(../../assets/images/jr5.png) no-repeat;
            background-size: cover;
            .leftImg {
                float: left;
                width: 45%;
                img {
                    width: 530px;
                    height: 350px;
                    margin-top: 70px;
                }

            }
            .rightCon {
                float: right;
                width: 53%;
                margin-top: 20px;
                .title1 {
                    color: #ffffff;
                }
                .tab {
                    display: inline-block;
                    color: #ffffff;
                    font-size: 14px;
                    border: 1px solid #ffffff;
                    margin-right: 10px;
                    padding: 2px 10px;
                    border-radius: 20px;
                    cursor: pointer;
                }
                .tab.active:hover {
                    color: #ffffff;
                }
                .tab.active {
                    background: -webkit-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -o-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -moz-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: linear-gradient(to right,#6BDEFF, #3C91FF);
                }
                .tabM {
                    margin-top: 15px;
                    border: 2px solid #2b4b87;
                    padding: 15px;
                    .tabCon {
                        background-color: #161644;
                        padding: 15px 10px 15px 10px ;
                        min-height: 160px;
                        .titleImg {
                            width: 20px;
                            height: 20px;
                            margin-right: 7px;
                        }
                        
                        .tabTitle {
                            color: #36B9FE;
                            font-size: 14px;
                            line-height: 23px;
                            vertical-align: bottom;
                            display: inline-block;
                        }
                        .yellow {
                            color: #FADB00;
                        }
                        .tabConItems {
                            padding: 10px 0 40px 27px;
                            .minTitle2 {
                                line-height: 20px;
                            }
                            .item {
                                display: inline-block;
                                color: #ffffff;
                                background: url(../../assets/images/rpa17.png) no-repeat;
                                background-size: auto 80%;
                                background-position-y: center;
                                text-indent: 17px;
                                width: 24%;
                                margin-bottom: 5px;
                            }
                        }
                    }
                }
                    

            }
        }
        .mb_button {
            display: none;
        }
        .lxwm2 {
            padding: 30px 0;
            
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        line-height: 20px;
                        margin-top: 15px;
                    }
                    .hs {
                        color: #333333;
                    }
                    .towLine {
                        line-height: 15px;
                        margin-top: 5px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
    .botton {
        .rightCon {
            width: 50%;
            margin-top: 40px;
            .tab {
                margin-bottom: 15px;
            }
            .tabM {
                margin-top: 0;
                .tabCon .tabConItems {
                    padding: 10px 0 0 0;
                }
            }
        }
        .title1 {
            display: none;
        }
    }
    
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 100%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .lxwm2 {
        .title1 {
            margin-bottom: 0;
            margin-top: 0;
        }
        .items {
            .item2 {
                width: 100%;
                margin-right: 0;
                padding: 15px 15px;
                .minTitle2 {
                    font-size: 14px;
                }
                .lb {
                    line-height: normal;
                }
                .tit {
                    display: flex;
                    align-items: center;
                    img {
                        height: 20px;
                    }
                }
            }
        }
    }
    
    .botton {
        display: none;
    }
    .mb_button {
        display: block;
        padding: 30px 20px;
        background: #111332 url(../../assets/images/jr5_mb.png) bottom center no-repeat;
        background-size: 100%;
        color: #fff;
        .block {
            padding: 0 10px;
        }
        /deep/ .el-carousel__indicators--horizontal {
            width: 100%;
            text-align: center;
        }
        .tit {
            color: #fff;
            text-align: center;
            font-size: 20px;
            margin-bottom: 20px;
        }
        .t {
            display: flex;
            align-items: center;
            color: #36b9fe;
            margin-bottom: 10px;
            font-size: 16px;
            img {
                width: 20px;
                height: 20px;
                margin-right: 7px;
            }
        }
    }
    .lxwm2.bg2 {
        display: none;
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
                color: #fff;
                margin-top: 26px;
                padding-right: 20px;
                box-sizing: border-box;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                    margin-top: 26px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
    }
}
</style>